<template>

    <div id="mycard" class="card">
      <div class="card-header bg-secondary" style="padding-top: 5px;padding-bottom: 5px;">
        <h5 style="padding: 0px">Extrusion Breakup</h5>
      </div>
      <div class="card-body" style="padding: 5px;">
        <div class="container"  >


          <table class="fixed_header">
            <!--<col style="width:30%">-->
            <!--<col style="width:40%">-->
            <!--<col style="width:30%">-->
            <thead>
              <tr>
                <th style="width: 75px;">S.No</th>
                <th >Container</th>
                <th style="text-align: right;padding-right: 30px;">Container Weight</th>
                <th style="text-align: right;padding-right: 25px;">Gross Weight</th>
              </tr>
            </thead>
            <tbody >
              <tr v-if="containers" v-for="(detail,index) in containers">
                <td style="width: 75px;"> {{index+1}}</td>
                <td >
                  <input type="number" min="999" max="9999" class="form-control-sm" style="width: 100%;" v-if="detail" v-model="detail.container.name" @change="container_change(index)" />
                </td>
                <td style="border-width: 1px;border-color: black;text-align: right;">
                  {{  weightFormat (detail.container.wgt) }}
                </td>
                <td >
                  <input class="form-control-sm" style="width: 100%; text-align: right;" v-if="detail" v-model="detail.wgt" @change="showSummary"/>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td  ><strong>Total</strong></td>
                <td ></td>
                <td style="text-align: right;padding-right: 25px;"> {{weightFormat (totalweight)}}</td>
              </tr>

            </tfoot>
          </table>
        </div>
      </div>
      <div class="card-footer text-right" >
        <button type="button" class="btn btn-outline-secondary" @click="saveData">Update</button>
      </div>
    </div>
</template>

<script>
  import {userService} from '@/store/auth-header.js'
  import moment from 'moment-timezone'
  import { store } from '@/store/store.js'
  export default {
    name: 'ExtrusionBreakupForm',
    props:{
      myqty:{
        type: Number,
        default: 0
      },
      myvoucher: {
        type: Object,
        default: () => JSON.parse('{"id":"","code":0,"status":0,"type":0,"finyear":0,"doc_no":0,"date":"0001-01-01","shift":{"id":"","code":0,"type":0,"name":""},"machine":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":""},"remarks":"","hdpe":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"hdpe_wgt":0,"color":{"id":"","code":0,"status":0,"name":"","p_name":"","wgt":0,"chart":null},"color_wgt":0,"quality":{"id":"","code":0,"name":"","p_name":"","colors_wgt":null},"yarn_container":0,"yarn":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_qty":0,"yarn_wgt":0,"yarn_waste":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_waste_wgt":0,"lumps":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"lumps_wgt":0,"operator":{"id":"","code":0,"status":0,"emp_code":"","name":"","designation":{"id":"","code":0,"name":"","min_wage":0}}}')
      }
    },
    data(){
      return {
        qty:0,
        voucher: JSON.parse('{"id":"","code":0,"status":0,"type":0,"finyear":0,"doc_no":0,"date":"0001-01-01","shift":{"id":"","code":0,"type":0,"name":""},"machine":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":""},"remarks":"","hdpe":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"hdpe_wgt":0,"color":{"id":"","code":0,"status":0,"name":"","p_name":"","wgt":0,"chart":null},"color_wgt":0,"quality":{"id":"","code":0,"name":"","p_name":"","colors_wgt":null},"yarn_container":0,"yarn":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_qty":0,"yarn_wgt":0,"yarn_waste":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_waste_wgt":0,"lumps":{"id":"","code":0,"nature":0,"ledger_group":{"id":"","code":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false,"system_object":false},"name":"","p_name":"","process":{"id":"","code":0,"name":"","nature":0,"p_name":""},"group":{"id":"","code":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":"","code":0,"name":"","digits":0},"subunit":{"id":"","code":0,"name":"","digits":0},"conv_fact":0,"has_bom":false,"sysobj":false},"design":{"id":"","code":0,"name":"","p_name":""},"color":{"id":"","code":0,"status":0,"name":"","p_name":""},"category":{"id":"","code":0,"name":"","p_name":""},"brand":{"id":"","code":0,"name":"","print_name":""},"style":{"id":"","code":0,"name":"","p_name":""},"unit":{"id":"","code":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"lumps_wgt":0,"operator":{"id":"","code":0,"status":0,"emp_code":"","name":"","designation":{"id":"","code":0,"name":"","min_wage":0}}}'),
        containers:[],
        mytable: {},
        totalweight: 0.0,
        container_map: new Map(),
      }
    },
    created(){

    },
    beforeMount(){
      let self = this;
      this.qty = parseInt(this.myvoucher.yarn_qty);
      this.voucher = this.myvoucher;

      for(var i=0; i < this.myqty; i++){
        self.$data.containers.push({"container":{"id":"","code":0,"status":0,"type":0,"name":"","wgt":0,"grs_wgt":0},"wgt":0});
      }
    },
    mounted(){
      let self = this;

      self.$data.mytable = $('#mycard');

      self.loadData();
    },
    methods:{
      weightFormat(wgt){
        if (wgt <= 0) {
          return '';
        }
        return wgt.toFixed(3);
      },
      showSummary(){
        let self = this;
        self.$data.totalweight = 0;

        self.$data.containers.forEach(function (cont) {
          self.$data.totalweight +=  parseFloat(cont.wgt);
        })
      },
      container_change(idx){
        let self = this;

        let container = self.$data.container_map.get(self.$data.containers[idx].container.name);
        self.$data.containers[idx].container = container;
        self.$data.containers[idx].container.code = parseInt(self.$data.containers[idx].container.name);

        self.showSummary();
      },
      loadData () {
        let self = this;

        const requestOptions = {
          method: 'GET',
          mode:"cors",
          headers: userService.authHeader()
        };

        $(self.$data.mytable).block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        //self.$data.containers = [];
        self.$data.container_map = new Map();
        fetch(`${process.env.VUE_APP_ROOT_API}v1/fms/container/`,requestOptions).then(userService.handleResponse).then(function (resp) {
          if(resp.accepted) {
            if(resp.data != null){
              //self.$data.containers = resp.data;
              resp.data.forEach(function (o) {
                self.$data.container_map.set(o.name, o);
              });
            }
          } else {
            swal ( { title: "Oh noes!" ,  text: resp.msg, type:  "error"} );
          }
        }).catch(function (err) {
          swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error"} );
        }).finally(function () {
          $(self.$data.mytable).unblock();
        });
      },
      saveData(){
        try{
          let count = 0;
          let self = this;

          self.$data.voucher.date = moment(self.$data.voucher.date).format('YYYY-MM-DD') + 'T00:00:00Z';

          self.$data.containers.forEach(function (det) {
            det.wgt = parseFloat(det.wgt);
            if (det.container.name.length < 3 ||  det.container.name.wgt <= det.wgt) {
              count++;
            }
          });


          if(count == 0){
            self.$data.voucher.containers = self.$data.containers;
            const requestOptions = {
              method:  'PUT',
              mode:"cors",
              headers: userService.authHeader(),
              body: JSON.stringify(self.$data.voucher)
            };
            fetch(`${process.env.VUE_APP_ROOT_API}v1/fms/extrusion/container/`,requestOptions).then(userService.handleResponse).then(function (data) {
              if(data.accepted) {
                swal ( { title: "Success!" ,  text: data.msg, type:  "success"} );
              } else {
                swal ( { title: "Oh noes!" ,  text: data.msg, type:  "error"} );
              }
            }).catch(function (err) {
              swal ( { title: "Oh noes!" ,  text: `failed to load data!`, type:  "error"} );
            });
          }else {
            alert( count +" Invalid Breakup Found");
          }

        }catch (e) {
          swal ( { title: "Error!" ,  text: e.toString(), type:  "error"} );
        }
      }
    }
  }
</script>

<style scoped>

  .fixed_header{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
  }

  .fixed_header tbody{
    display:block;
    width: 100%;
    overflow: auto;
    height: 360px;
  }

  .fixed_header thead tr {
    display: block;
  }

  .fixed_header thead {
    background: dimgrey;
    color:#fff;
    width: 100%;
  }

  .fixed_header th, .fixed_header td {
    padding: 5px;
    text-align: left;
    width: 1500px;
  }
  .fixed_header th{
    height: 40px;
  }

  .fixed_header tfoot tr {
    display: block;
  }

  .fixed_header tfoot {
    background: dimgrey;
    color:#fff;
  }
  input:focus {
    background: #feff00;

  }

  textarea:focus {
    background: #feff00;

  }

  select:focus {
    background: #feff00;
  }

  button:focus {
    background: #feff00;
    color: #0a0a0a!important;
  }
</style>
